<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >Invitación a trabajar</span
            >
            <button
                style="float: right"
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <h2>
            Contratistas a invitar

            <span class="badge accent">{{ data.contratistas.length }}</span>
        </h2>
        <mat-divider></mat-divider>
        <table class="simple mt-8">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Contratista</th>

                    <th>Evaluación</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    *ngFor="
                        let contratista of data.contratistas;
                        let idx = index
                    "
                >
                    <td>
                        <strong>{{ idx + 1 }}.- </strong>
                    </td>
                    <td>
                        <strong
                            >{{ contratista.nombres }}
                            {{ contratista.apellidos }}
                        </strong>
                        <br />
                        <small> {{ contratista.rut }}</small>
                    </td>
                    <td>
                        <app-star-rating
                            [seteable]="false"
                            [evaluacion]="contratista.evaluacion"
                            [cantidadEstrellas]="
                                config.rating.cantidadEstrellas
                            "
                        ></app-star-rating>
                    </td>
                </tr>
            </tbody>
        </table>

        <h2>Invitación a trabajar</h2>
        <mat-divider></mat-divider>
        <div *ngIf="mostrarAvisoMontoOfertado" class="message-box accent">
            Monto ofertado a pagar
            <strong
                >{{ montoOfertado.value | currency: "CLP":"symbol-narrow" }}
            </strong>
            Excede el monto de la OOTT
            {{ data.valorCotizado | currency: "CLP":"symbol-narrow" }}
        </div>
        <form class="form mt-8" [formGroup]="formInvitacion" autocomplete="off">
            <div
                fxLayout="row"
                fxLayout.lt-md="column"
                fxLayoutAlign="start"
                fxLayoutGap.xs="0"
                fxLayoutGap="30px"
            >
                <div fxFlex="50%" fxFlex.lt-md="100%" fxLayoutAlign="center">
                    <mat-form-field class="width-80">
                        <mat-label>Monto ofertado </mat-label>
                        <input
                            matInput
                            type="text"
                            formControlName="montoOfertado"
                            required
                            min="0"
                        />
                        <span matPrefix>$&nbsp;</span>
                        <mat-error *ngIf="montoOfertado.hasError('required')">
                            Debe ingresar el monto ofertado
                        </mat-error>
                        <mat-error *ngIf="montoOfertado.hasError('min')">
                            Debe ingresar un monto válido
                        </mat-error>
                        <mat-error *ngIf="montoOfertado.hasError('pattern')">
                            El monto debe ser numérico
                        </mat-error>
                    </mat-form-field>
                </div>
                <div fxFlex="50%" fxFlex.lt-md="100%" fxLayoutAlign="center">
                    <!--    <mat-checkbox formControlName="incluyeMateriales"
                        >Incluye materiales</mat-checkbox
                    >-->

                    <mat-form-field class="width-80">
                        <mat-label>Inicio y término del trabajo </mat-label>
                        <mat-date-range-input
                            [formGroup]="rango"
                            [rangePicker]="picker"
                        >
                            <input
                                matStartDate
                                formControlName="fechaInicioTrabajo"
                                placeholder="Fecha de inicio"
                                readonly
                                required
                            />
                            <input
                                matEndDate
                                formControlName="fechaTerminoTrabajo"
                                placeholder="Fecha de término"
                                readonly
                                required
                            />
                        </mat-date-range-input>
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="picker"
                        ></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>

                        <mat-error
                            *ngIf="
                                fechaInicioTrabajo.hasError('required') ||
                                fechaTerminoTrabajo.hasError('required')
                            "
                        >
                            Debe ingresar la fecha de inicio y de término
                        </mat-error>
                        <mat-error
                            *ngIf="
                                fechaInicioTrabajo.hasError(
                                    'matStartDateInvalid'
                                )
                            "
                            >Fecha de inicio inválida</mat-error
                        >
                        <mat-error
                            *ngIf="
                                fechaTerminoTrabajo.hasError(
                                    'matEndDateInvalid'
                                )
                            "
                            >Fecha de término inválida</mat-error
                        >
                    </mat-form-field>
                </div>
            </div>
            <div
                fxLayout="row"
                fxLayout.lt-md="column"
                fxLayoutAlign="center center"
                fxLayoutGap.xs="0"
            >
                <div fxFlex="50%" fxFlex.lt-md="100%" fxLayoutAlign="center">
                    <mat-form-field class="width-80">
                        <mat-label>Fecha vigencia invitación </mat-label>

                        <input
                            matInput
                            [matDatepicker]="fechaVigenciaDatePicker"
                            name="fechaVigencia"
                            formControlName="fechaVigencia"
                            readonly
                            required
                        />
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="fechaVigenciaDatePicker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker
                            #fechaVigenciaDatePicker
                        ></mat-datepicker>
                        <mat-error *ngIf="fechaVigencia.hasError('required')">
                            Debe ingresar la fecha de vigencia
                        </mat-error>
                    </mat-form-field>
                </div>
                <div fxFlex="50%" fxFlex.lt-md="100%" fxLayoutAlign="center">
                    <mat-form-field class="width-80">
                        <mat-label>Hora de vigencia </mat-label>

                        <input
                            type="time"
                            matInput
                            name="horaVigencia"
                            formControlName="horaVigencia"
                            required
                            placeholder="HH:MM"
                        />
                        <mat-hint>Entre 00:00 y 23:59</mat-hint>
                        <mat-error *ngIf="horaVigencia.hasError('required')">
                            Debe ingresar la hora de vigencia
                        </mat-error>

                        <mat-error *ngIf="horaVigencia.hasError('pattern')">
                            El formato de la hora es inválido
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div
                fxLayout="row"
                fxLayout.lt-md="column"
                fxLayoutAlign="start"
                fxLayoutGap.xs="0"
            >
                <div
                    fxFlex="50%"
                    fxFlex.lt-md="100%"
                    fxLayoutAlign="center"
                ></div>
                <div
                    fxFlex="50%"
                    fxFlex.lt-md="100%"
                    fxLayoutAlign="center"
                ></div>
            </div>
        </form>
    </mat-dialog-content>
    <mat-divider></mat-divider>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cancelar</button>

        <button
            mat-raised-button
            color="accent"
            [disabled]="!formInvitacion.valid || procesando == true"
            (click)="generarInvitacionTrabajo()"
        >
            Invitar a trabajar
        </button>
    </mat-dialog-actions>
</div>
